import React from 'react';
import styled from 'styled-components';
import { getColor } from 'common/constants/_colors';
import { calculatePercentage } from 'common/utils/utils';
import { Flex } from './base/layout-components';

const Railing = styled(Flex)`
  height: 0.8rem;
  width: ${({ size }) => (size ? `${size}%` : 0)};
`;

const Progress = styled(Flex)`
  border-radius: 0.4rem;
  background-color: ${({ color, opacity }) => `${getColor(color, opacity)}`};
  width: 100%;
`;
const RelativeBar = ({
  value,
  maxValue,
  color = 'pigeonPost',
  opacity = 1,
  ...other
}) => {
  const size = calculatePercentage(value, maxValue);
  return (
    <Railing {...other} size={size}>
      <Progress percent={size} color={color} opacity={opacity} />
    </Railing>
  );
};

export default RelativeBar;
